export default "__VITE_ASSET__Bril8UXq__"